module.exports = __webpack_public_path__ + "img/1f956.466fea6.svg";